var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "section section-bold" }, [
    _c("div", { staticClass: "section-title" }, [
      _vm._v("\n\t\t" + _vm._s(_vm.title) + "\n\t\t"),
      _c(
        "span",
        { staticClass: "category-title-btn", on: { click: _vm.close } },
        [_c("i", { staticClass: "material-icons md-14" }, [_vm._v("close")])]
      )
    ]),
    _vm._v(" "),
    _c("form", { staticClass: "section-body" }, [
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title overflow-hidden" }, [
          _vm._v("\n\t\t\t\tLOT SIZE\n\t\t\t")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotSize.minArea,
                  expression: "rec.lotSize.minArea",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "area in ft²" },
              domProps: { value: _vm.rec.lotSize.minArea },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotSize,
                    "minArea",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Maximum area")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotSize.maxArea,
                  expression: "rec.lotSize.maxArea",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "area in ft²" },
              domProps: { value: _vm.rec.lotSize.maxArea },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotSize,
                    "maxArea",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Minimum width")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotSize.minWidth,
                  expression: "rec.lotSize.minWidth",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.lotSize.minWidth },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotSize,
                    "minWidth",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Minimum width corner")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotSize.minWidthCorner,
                  expression: "rec.lotSize.minWidthCorner",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.lotSize.minWidthCorner },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotSize,
                    "minWidthCorner",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Minimum frontage")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotSize.minFrontage,
                  expression: "rec.lotSize.minFrontage",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.lotSize.minFrontage },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotSize,
                    "minFrontage",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Minimum depth")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotSize.minDepth,
                  expression: "rec.lotSize.minDepth",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.lotSize.minDepth },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotSize,
                    "minDepth",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [_vm._v("DENSITY")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("SF/DU")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right property-locked" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.density.sfDu,
                  expression: "rec.density.sfDu",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.density.sfDu },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.density, "sfDu", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("SF/DU note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.density.sfDuNote,
                  expression: "rec.density.sfDuNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notations" },
              domProps: { value: _vm.rec.density.sfDuNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.density, "sfDuNote", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [_vm._v("HEIGHT LIMIT")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Height maximum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right property-locked" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.heightLimit.max,
                  expression: "rec.heightLimit.max",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.heightLimit.max },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.heightLimit,
                    "max",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Above enclosed parking")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right property-locked" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.heightLimit.aboveEnclosedParking,
                  expression: "rec.heightLimit.aboveEnclosedParking",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.heightLimit.aboveEnclosedParking },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.heightLimit,
                    "aboveEnclosedParking",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Roof flat limit")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.heightLimit.roofFlat,
                  expression: "rec.heightLimit.roofFlat",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.heightLimit.roofFlat },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.heightLimit,
                    "roofFlat",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Roof pitched limit")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.heightLimit.roofPitched,
                  expression: "rec.heightLimit.roofPitched",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.heightLimit.roofPitched },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.heightLimit,
                    "roofPitched",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Height note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.heightLimit.note,
                  expression: "rec.heightLimit.note",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.heightLimit.note },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.heightLimit, "note", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [
          _vm._v("FLOOR TO AREA RATIO (FAR)")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR base")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.far.base,
                  expression: "rec.far.base",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.far.base },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.far, "base", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR minimum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.far.min,
                  expression: "rec.far.min",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.far.min },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.far, "min", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR maximum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.far.max,
                  expression: "rec.far.max",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.far.max },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.far, "max", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR residential")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.far.residential,
                  expression: "rec.far.residential",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.far.residential },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.far,
                    "residential",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR commercial")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.far.commercial,
                  expression: "rec.far.commercial",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.far.commercial },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.far,
                    "commercial",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR mixed")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.far.mixed,
                  expression: "rec.far.mixed",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "ratio" },
              domProps: { value: _vm.rec.far.mixed },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.far, "mixed", _vm._n($event.target.value))
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("FAR note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.far.note,
                  expression: "rec.far.note",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.far.note },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.far, "note", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [_vm._v("SETBACKS")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Front minimum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.setbacks.frontMin,
                  expression: "rec.setbacks.frontMin",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.setbacks.frontMin },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "frontMin",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Front minimum note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.setbacks.frontMinNote,
                  expression: "rec.setbacks.frontMinNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.setbacks.frontMinNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "frontMinNote",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Front maximum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.setbacks.frontMax,
                  expression: "rec.setbacks.frontMax",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.setbacks.frontMax },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "frontMax",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Front maximum note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.setbacks.frontMaxNote,
                  expression: "rec.setbacks.frontMaxNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.setbacks.frontMaxNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "frontMaxNote",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Interior side")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.setbacks.interiorSide,
                  expression: "rec.setbacks.interiorSide",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.setbacks.interiorSide },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "interiorSide",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Interior side note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.setbacks.interiorSideNote,
                  expression: "rec.setbacks.interiorSideNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.setbacks.interiorSideNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "interiorSideNote",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Street side")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.setbacks.streetSide,
                  expression: "rec.setbacks.streetSide",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.setbacks.streetSide },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "streetSide",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Street side note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.setbacks.streetSideNote,
                  expression: "rec.setbacks.streetSideNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.setbacks.streetSideNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "streetSideNote",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Rear")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.setbacks.rear,
                  expression: "rec.setbacks.rear",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.setbacks.rear },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "rear",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Rear Alley")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.setbacks.rearAlley,
                  expression: "rec.setbacks.rearAlley",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "distance in ft" },
              domProps: { value: _vm.rec.setbacks.rearAlley },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.setbacks,
                    "rearAlley",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Rear note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.setbacks.rearNote,
                  expression: "rec.setbacks.rearNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.setbacks.rearNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.setbacks, "rearNote", $event.target.value)
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("General note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.setbacks.generalNote,
                  expression: "rec.setbacks.generalNote",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.setbacks.generalNote },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.setbacks, "generalNote", $event.target.value)
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "category" }, [
        _c("div", { staticClass: "category-title" }, [_vm._v("LOT COVERAGE")]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Lot coverage minimum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotCoverage.min,
                  expression: "rec.lotCoverage.min",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "area in ft²" },
              domProps: { value: _vm.rec.lotCoverage.min },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotCoverage,
                    "min",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Lot coverage maximum")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.number",
                  value: _vm.rec.lotCoverage.max,
                  expression: "rec.lotCoverage.max",
                  modifiers: { number: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "area in ft²" },
              domProps: { value: _vm.rec.lotCoverage.max },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.rec.lotCoverage,
                    "max",
                    _vm._n($event.target.value)
                  )
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "property-row" }, [
          _c("label", [_vm._v("Lot coverage note")]),
          _vm._v(" "),
          _c("div", { staticClass: "property-value-right" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.string",
                  value: _vm.rec.lotCoverage.note,
                  expression: "rec.lotCoverage.note",
                  modifiers: { string: true }
                }
              ],
              staticClass: "form-control form-control-sm",
              attrs: { placeholder: "notation" },
              domProps: { value: _vm.rec.lotCoverage.note },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.rec.lotCoverage, "note", $event.target.value)
                }
              }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "section-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary float-right",
          on: { click: _vm.submit }
        },
        [_vm._v(_vm._s(_vm.submitLabel))]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Minimum area "),
      _c("small", [_vm._v("(leave empty for no min)")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9382e41e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9382e41e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/zoning/regulation-form.vue
// module id = null
// module chunks = 